module.exports = "#nav-manage {\r\n    display: block;\r\n    max-height: 500px;\r\n    overflow: auto;\r\n}\r\n\r\n@media (max-width: 600px){\r\n    .btn-name {\r\n        max-width: 182px;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navigation/navigation.component.css
// module id = ./src/app/components/navigation/navigation.component.css
// module chunks = main